var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.528 56.8L26.128 38.4H34.4V32H18.4C16.6313 32 15.2 33.4313 15.2 35.2V51.2H21.6V42.928L40 61.328L44.528 56.8Z",
    fill: "#19EF88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 44.8V28.8H58.4V37.072L40 18.672L35.4719 23.2002L53.8719 41.6002H45.5999V48.0002H61.5999C62.4499 48.0002 63.2623 47.6627 63.8623 47.0626C64.4623 46.4626 64.7999 45.6502 64.7999 44.8002L64.8 44.8Z",
    fill: "#19EF88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchArrows);
export default __webpack_public_path__ + "static/media/switch-arrows.525ac8335c509bbbfc13f30413116ebc.svg";
export { ForwardRef as ReactComponent };